export const units = [
  {
    key: 'piece',
    label: 'units.piece',
  },
  {
    key: 'items',
    label: 'units.items',
  },
  {
    key: 'pallets',
    label: 'units.pallets',
  },
  {
    key: 'boxes',
    label: 'units.boxes',
  },
  {
    key: 'squaremeters',
    label: 'units.squaremeters',
  },
  {
    key: 'cubicmeters',
    label: 'units.cubicmeters',
  },
  {
    key: 'kg',
    label: 'units.kg',
  },
  {
    key: 'litre',
    label: 'units.litre',
  },
];

export const tangible_asset_types = [
  {
    key: 'operatingAndBusinessEquipment',
    label: 'tangibleAssetType.operatingAndBusinessEquipment',
  },
  {
    key: 'machine',
    label: 'tangibleAssetType.machine',
  },
  {
    key: 'vehicle',
    label: 'tangibleAssetType.vehicle',
  },
  {
    key: 'supplies',
    label: 'tangibleAssetType.supplies',
  },
  {
    key: 'intangibleAssets',
    label: 'tangibleAssetType.intangibleAssets',
  },
  {
    key: 'landAndBuildings',
    label: 'tangibleAssetType.landAndBuildings',
  },
  {
    key: 'privateFurnishings',
    label: 'tangibleAssetType.privateFurnishings',
  },
  {
    key: 'securitiesAndInsurance',
    label: 'tangibleAssetType.securitiesAndInsurance',
  },
];

// Content scope of an inventory item (RIEG-249 WP4). Four values, distinct from
// the asset-type dropdown (`tangible_asset_types`): "Posten" is a content scope,
// not an asset type. Default is `noContent`. Mirrors the { key, label } shape of
// `tangible_asset_types`; labels resolve via the `inventoryScope.*` i18n keys.
//
// Order is the order the scope dialog offers them in, and it is deliberate:
// `withContent` sits directly behind the `noContent` default because those two
// are the pair an appraiser actually chooses between (RIEG-263). `roomContent`
// and `items` are the rarer cases and follow.
export const inventory_scopes = [
  {
    key: 'noContent',
    label: 'inventoryScope.noContent',
  },
  {
    key: 'withContent',
    label: 'inventoryScope.withContent',
  },
  {
    key: 'roomContent',
    label: 'inventoryScope.roomContent',
  },
  {
    key: 'items',
    label: 'inventoryScope.items',
  },
];

export const goods_types = [
  {
    key: 'freeMass',
    label: 'goodsType.freeMass',
  },
  {
    key: 'freeMass1006bgb',
    label: 'goodsType.freeMass1006bgb',
  },
  {
    key: 'segregation',
    label: 'goodsType.segregation',
  },
  {
    key: 'singleOut',
    label: 'goodsType.singleOut',
  },
];

export const drives = [
  {
    key: 'pneumatic',
    label: 'drive.pneumatic',
  },
  {
    key: 'electric',
    label: 'drive.electric',
  },
  {
    key: 'battery',
    label: 'drive.battery',
  },
  {
    key: 'hydraulic',
    label: 'drive.hydraulic',
  },
  {
    key: 'manual',
    label: 'drive.manual',
  },
];

export const conditions = [
  {
    key: 1,
    label: 'condition.1',
  },
  {
    key: 2,
    label: 'condition.2',
  },
  {
    key: 3,
    label: 'condition.3',
  },
  {
    key: 4,
    label: 'condition.4',
  },
  {
    key: 5,
    label: 'condition.5',
  },
  {
    key: 6,
    label: 'condition.6',
  },
];
